// extracted by mini-css-extract-plugin
export default {"timestamp":"timestamp__LaVXW7"};